import { Component } from '@theme/component';

/**
 * Custom search bar component.
 *
 * @extends Component<{}>
 */
export class SearchBar extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;

    this.input = this.querySelector('input');
    this.icon = this.querySelector('.search-icon');

    if (!this.input) return;

    this.input.addEventListener('keypress', this.#handleKeyPress, { signal });

    this.icon?.addEventListener('click', this.#handleSearchClick, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }
  /**
   * @param {KeyboardEvent} event
   */
  #handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.#goSearch();
    }
  };

  #handleSearchClick = () => {
    this.#goSearch();
  };

  #goSearch() {
    const text = this.input?.value.trim();
    if (!text) return;

    const url = `/search?q=${encodeURIComponent(text)}&type=article`;

    window.location.href = url;
  }
}

if (!customElements.get('search-article')) {
  customElements.define('search-article', SearchBar);
}
